import { AuthService } from './../../../../../services/auth.service';
import { HelperService } from './../../../../../services/helper.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-delete-snapshot',
  templateUrl: './delete-snapshot.component.html',
  styleUrls: ['./delete-snapshot.component.scss']
})
export class DeleteSnapshotComponent implements OnInit, OnChanges {

  @Input() deletedSnapshotData;
  @Input() hotspotType;
  @Output() modalCloseEmit = new EventEmitter();
  @Output() modalCloseDeleteSnapshotEmit = new EventEmitter();
  @Output() modalCloseSnapshotDeleteEmit = new EventEmitter();

  isSubmitted = false;
  accessToken: any;
  deleteError;
  deleteSuccess;
  constructor(
    public memberService: MemberService,
    public authService: AuthService,
    public helperService: HelperService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.resetErrorValues();

    // tslint:disable-next-line:only-arrow-functions
    $('#deleteSnapshotModal').on('click', '[data-dismiss="modal"]', function(e) {
      e.stopPropagation();
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes. deletedSnapshotData && changes. deletedSnapshotData.currentValue) {
      this.resetErrorValues();
    }
  }

  deleteSnapshots() {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.deleteSnapshotsEmit();
  }

  deleteSnapshotsEmit() {
    this.deleteError = undefined;
    // const deletedSnapshotData = this.deletedSnapshotData;
    let i;
    const snapshotArray = [];
    for (i = 0; i < this.deletedSnapshotData.length; i++) {
      snapshotArray.push(this.deletedSnapshotData[i].uuid);
    }
    const data = {
      snapshot: snapshotArray
    };

    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.deleteMultipleSnapshots({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.deleteSuccess = 'Snapshot was successfully deleted.';
      setTimeout(() => {
        this.modalCloseEmit.emit(true);
      }, 2000);
    }, err => {
      if (err.error && err.error.error) {
        this.deleteError = err.error.error;
      } else {
        this.deleteError = 'There was error while deleting snapshot.';
      }
    });

  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteSuccess = undefined;
    this.deleteError = undefined;
  }

  closeModal() {
    this.modalCloseEmit.emit(undefined);
  }

  onClickOutside(event: any) {
    if (event && event.value === true) {
      this.modalCloseSnapshotDeleteEmit.emit(undefined);
    }
  }

}
